import React, { Suspense } from "react";
import { Box, Flex } from "@chakra-ui/react";
import MyDashboardHeader from "@/features/my-dashboard/components/MyDashboardHeader";
import MyDashboardLinkedSite from "@/features/my-dashboard/components/MyDashboardLinkedSite";
import MyDashboardMainSection from "@/features/my-dashboard/components/MyDashboardMainSection";
import MyDashboardBeforeLinkage from "@/features/my-dashboard/components/linkage/MyDashboardBeforeLinkage";
import useIdentity from "@/features/ui/hooks/use-identity";
import useGetMyDashboardLinkedUrlSiteInfo from "@/features/my-dashboard/hooks/useGetMyDashboardLinkedUrlSiteInfo";
import CenteredSpinner from "@/shared/components/centered-spinner";
import { Helmet } from "react-helmet-async";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

function MyDashBoardPage() {
  const { tTitle } = useI18nHelper();
  return (
    <>
      <Helmet>
        <title>Pathrade | {tTitle("my_dashboard")}</title>
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta property="og:title" content="Pathrade | API Order Sheets" />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      <Flex
        flexDirection={"column"}
        height={"100%"}
        maxH={"calc(100vh - 52px)"}
        minW={"1136px"}
      >
        <MyDashboardHeader />
        <Flex padding={"12px 16px"} flexDirection={"column"} gap={"12px"}>
          <Suspense
            fallback={
              <Box minH={"600px"}>
                <CenteredSpinner />
              </Box>
            }
          >
            <MyDashboardMainContent />
          </Suspense>
        </Flex>
      </Flex>
    </>
  );
}

export default MyDashBoardPage;

const MyDashboardMainContent = () => {
  const identity = useIdentity();
  const { linkedUrlSiteInfo } = useGetMyDashboardLinkedUrlSiteInfo(
    identity?.company?.id
  );
  const hasRequested = !!linkedUrlSiteInfo;
  const requestStatus = linkedUrlSiteInfo?.status;

  return (
    <>
      {requestStatus === "COMPLETED" ? (
        <>
          <MyDashboardLinkedSite />
          <MyDashboardMainSection />
        </>
      ) : (
        <MyDashboardBeforeLinkage
          status={requestStatus}
          hasRequested={hasRequested}
        />
      )}
    </>
  );
};
